import type { RouteObject } from "react-router";
import type { ShellHandle } from "../layouts/AppShell.tsx";
import { FieldLayout } from "./FieldLayout.tsx";

/**
 * Field capture ("One Lap"), mounted at /field inside the signed-in app
 * shell (src/router.tsx). Every screen reads the device store rather than a
 * loader, so it opens offline from the saved shell; the service worker
 * serves the app itself.
 *
 *   /field                        S1 Today: visits on this device, start a visit, sync
 *   /field/visits/:id             set-up first, then the lap
 *   /field/visits/:id/setup       S2 Set-up
 *   /field/visits/:id/lap         S3 Lap, with S4 keypad, S5 run sheet, S6 roof, S7 checklist
 *   /field/visits/:id/review      S9 Ledger review (and S10 3D on demand)
 *
 * The HID bench page (/field/bench) needs no sign-in, so it sits outside
 * the shell (fieldBenchRoute, registered in src/router.tsx).
 *
 * The shell's phone credit is off here: S1 Today shows the Platform21
 * credit itself, in the sun theme, and the set-up, lap, keypad and review
 * screens carry none.
 */
const FIELD_HANDLE: ShellHandle = { shellCredit: false };

export const fieldRoutes: RouteObject[] = [
  {
    Component: FieldLayout,
    handle: FIELD_HANDLE,
    children: [
      { index: true, lazy: () => import("./FieldHome.tsx") },
      { path: "visits/:visitId", lazy: () => import("./screens/VisitIndex.tsx") },
      { path: "visits/:visitId/setup", lazy: () => import("./screens/SetupScreen.tsx") },
      { path: "visits/:visitId/lap", lazy: () => import("./screens/LapScreen.tsx") },
      { path: "visits/:visitId/review", lazy: () => import("./screens/ReviewScreen.tsx") },
    ],
  },
];

/** S3 spike: the laser bench test. Outside the app shell, so it works signed out. */
export const fieldBenchRoute: RouteObject = {
  path: "field/bench",
  lazy: () => import("./bench/BenchPage.tsx"),
};
